<template>
  <svg t="1688279023338" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="17475" width="200" height="200"><path d="M919.488 264.512V832c0 46.912-38.4 85.312-85.376 85.312h-640c-46.912 0-85.312-38.4-85.312-85.312V192c0-46.912 38.4-85.312 85.312-85.312H761.6c6.4 0 10.688 2.112 14.912 6.4L913.088 249.6c4.224 4.288 6.4 8.512 6.4 14.912z" fill="#858EBD" p-id="17476"></path><path d="M322.112 106.688h384V320h-384V106.688z m-64 533.312h512v277.312h-512V640z" fill="#FFFFFF" p-id="17477"></path><path d="M599.488 149.312h64v128h-64v-128z m-234.688 576h298.688v21.376H364.8v-21.376z m0 85.376h298.688V832H364.8v-21.312z" fill="#858EBD" p-id="17478"></path></svg>
</template>
<script>
export default {
}
</script>
<style scoped>
.svg-node {
  left: 1px;
  top: 1px;
  width: 32px;
  height: 30px;
  display: block;
  position: relative;
  overflow: hidden;
}
</style>
